import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CacheBuster from 'react-cache-buster';        // ← ADD
import packageJson from '../package.json';   // ← changed

import MainQuora from './quora/MainQuora';
import QuestionDetails from './quora/QuestionDetails';
import UserApiKey from './quora/UserApiKey';
import PromptLibraryPage from './quora/PromptLibraryPage';
import AnglesPage from './quora/AnglesPage';
import { ToastContainer } from 'react-toastify';
import Login from './auth/Login';
import Register from './auth/Register';
import ResetPassword from './auth/ResetPassword';

function PrivateRoute({ element }) {
  const user = localStorage.getItem('user');
  return user ? element : <Navigate to="/register" />;
}

function App() {

const isProduction = true; 

  return (
   <CacheBuster
      currentVersion={packageJson.version}    // ← changed
      isEnabled={isProduction}
      isVerboseMode={false}
    >
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        <Router>
          <div>
            <Routes>
              <Route path="/"               element={<PrivateRoute element={<MainQuora />} />} />
              <Route path="/questions/:id"  element={<QuestionDetails />} />
              <Route path="/login"          element={<Login />} />
              <Route path="/register"       element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/api-settings"   element={<PrivateRoute element={<UserApiKey />} />} />
              <Route path="/prompt-library" element={<PrivateRoute element={<PromptLibraryPage />} />} />
              <Route path="/angles"         element={<PrivateRoute element={<AnglesPage />} />} />
            </Routes>
          </div>
        </Router>
      </>
    </CacheBuster>                      // ← CLOSE
  );
}

export default App;